import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import 'src/index.css';
import App from 'src/App';

import * as serviceWorker from 'src/serviceWorker';

import FullScreenLoading from 'src/components/FullScreenLoading';
import AppContexts from 'src/contexts/AppContexts';
import BUILD_INFO from 'src/consts/URLS/data.json';
import axios from 'axios';
import installApiTracing from 'src/utils/installApiTracing';
import app_config from 'src/config';

installApiTracing({
  client_app: 'meny-client',
  client_version: process.env.NODE_ENV,
  axios_instance: axios,
  api_prefixes: [app_config.REST_MNGT_ENDPOINT],
});

console.log('hello from menymeny.com', BUILD_INFO.GIT_COMMIT);

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
  console.assert = () => {};
  console.warn = () => {};

  if (window.location.href.search('web.app') === -1) {
    console.debug = () => {};
    console.error = () => {};
  }
}

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<FullScreenLoading />}>
      <AppContexts>
        <App style={{ overflow: 'hidden' }} />
      </AppContexts>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
